import './scss/index.scss';
import { dcFactory } from 'dc';
import { SignUpComponent } from './js/sign-up.component';

dcFactory.register(SignUpComponent);
